<script setup>
import {Carousel, Slide} from "vue3-carousel"
import CourseItem from "./Courses/CourseItem.vue"
import {ref} from "vue";
import ChevronSvg from "@svg/new-chevron.svg";
import ClientOnly from "@duannx/vue-client-only";

defineProps({
    courses: Array
})

const carousel = ref(null)
const currentSlide = ref(0)
</script>

<template>
    <ClientOnly>
        <Carousel
            ref="carousel"
            :items-to-show="1"
            snapAlign="start"
            :wrapAround="true"
            class="!text-left relative after:absolute after:right-0 after:h-full after:top-0 after:w-28 after:z-20 after:bg-gradient-to-r after:from-transparent after:to-[rgba(8,13,39,1)] after:pointer-events-none"
            v-model="currentSlide"
            :breakpoints="{
                1210: {
                    itemsToShow: 3.1
                },

                768: {
                    itemsToShow: 2.1
                }
            }"
        >
            <Slide v-for="course in courses" :key="course.id">
                <div class="pr-3 md:pr-6">
                    <CourseItem :course="course" :showDifficulty="false" />
                </div>
            </Slide>
        </Carousel>
    </ClientOnly>

    <button
        class="text-white absolute inset-y-0 -left-20 flex items-center opacity-0 transition-opacity pointer-events-none"
        v-on:click="carousel.prev()"
        :class="{ '!opacity-100 !pointer-events-auto': currentSlide > 1 || currentSlide === 0 }"
    >
        <ChevronSvg class="size-10 md:size-12 rotate-90 text-[rgba(132,156,241,1)]" />
    </button>

    <button
        class="text-white absolute inset-y-0 -right-2 xl:-right-14 z-20 flex items-center"
        v-on:click="carousel.next()"
    >
        <ChevronSvg class="size-10 md:size-12 rotate-[270deg] text-[rgba(132,156,241,1)]" />
    </button>
</template>
